export default __webpack_public_path__ + "static/media/cric-player.f4283333.png";